import {
  Box,
  Button,
  Flex,
  Input,
  InputGroup,
  InputLeftElement,
  Select,
  Text,
} from "@chakra-ui/react";
import React from "react";
import { RiSearch2Fill } from "react-icons/ri";
import { useSelector } from "react-redux";
import { brandPalette } from "../../../constants/brandPalette";

const C = {
  primary: brandPalette.primary,
  secondary: brandPalette.accentDark,
  border: brandPalette.stone,
  muted: "rgba(30, 27, 23, 0.6)",
};

const SearchBar = ({
  searchTerm,
  setSearchTerm,
  filterType,
  setFilterType,
}) => {
  const list = useSelector((state) => state.whatsappTemplates.list);
  const count = Array.isArray(list) ? list.length : 0;

  return (
    <Box px={{ base: 4, md: 8 }} pt={6} pb={0} w="100%">
      <Flex
        align={{ base: "flex-start", md: "flex-end" }}
        justify="space-between"
        gap={6}
        flexDir={{ base: "column", md: "row" }}
        mb={6}
      >
        <Box>
          <Text
            fontSize={{ base: "32px", md: "54px" }}
            fontWeight="800"
            color={C.primary}
            fontFamily="'Amiri', 'Tajawal', sans-serif"
            lineHeight="1"
          >
            WhatsApp Templates
          </Text>
          <Text mt={3} color={C.muted} fontSize="sm" maxW="lg">
            Review and edit WhatsApp templates before submitting them to Meta.
          </Text>
          <Text mt={2} fontSize="sm" fontWeight="700" color={C.secondary}>
            Total: {count}
          </Text>
        </Box>
      </Flex>

      <Flex
        mb={6}
        gap={3}
        flexDir={{ base: "column", md: "row" }}
        align={{ base: "stretch", md: "center" }}
        maxW="720px"
      >
        <InputGroup flex="1">
          <InputLeftElement pointerEvents="none" h="full">
            <RiSearch2Fill color="rgba(91, 13, 22, 0.5)" fontSize="18px" />
          </InputLeftElement>
          <Input
            placeholder="Search by name, display name, or message…"
            value={searchTerm}
            borderRadius="full"
            border="1px solid"
            borderColor={C.border}
            bg="var(--surface-raised)"
            pl={10}
            _focus={{
              borderColor: C.primary,
              boxShadow: "0 0 0 1px rgba(91, 13, 22, 0.2)",
            }}
            onChange={(e) => setSearchTerm(e.target.value)}
          />
        </InputGroup>

        <Select
          maxW={{ base: "100%", md: "220px" }}
          borderRadius="full"
          borderColor={C.border}
          bg="var(--surface-raised)"
          value={filterType}
          onChange={(e) => setFilterType(e.target.value)}
        >
          <option value="all">All templates</option>
          <option value="scan">Scan templates</option>
          <option value="other">Other templates</option>
        </Select>

        {(searchTerm || filterType !== "all") && (
          <Button
            variant="ghost"
            color={C.primary}
            onClick={() => {
              setSearchTerm("");
              setFilterType("all");
            }}
          >
            Clear
          </Button>
        )}
      </Flex>
    </Box>
  );
};

export default SearchBar;
